import { c as _c } from "react/compiler-runtime";
import { IcoCamera40, IcoClose24 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { Trans, useTranslation } from 'react-i18next';
import { TOUCH_TARGET_CLASS } from '@/idv2/components/constants';
import type { DeviceInfo } from '@/idv2/hooks';
import { isAndroid, isChrome, isIOS, isMobileKind, isSafari } from '../../utils/capture';
import IcoArrowCustom from './ico-arrow-custom';
type CameraAccessDeniedProps = {
  device: DeviceInfo;
  onClose: () => void;
};
const gifBaseUrl = 'https://i.onefp.net/i';
const CameraAccessDenied = t0 => {
  const $ = _c(40);
  const {
    onClose,
    device
  } = t0;
  let t1;
  if ($[0] !== device) {
    t1 = device || {};
    $[0] = device;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    browser,
    osName,
    type
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "document-flow"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  let t3;
  if ($[3] !== osName || $[4] !== type) {
    t3 = isMobileKind(type) && isAndroid(osName);
    $[3] = osName;
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isMobileOrTabletAndroid = t3;
  let t4;
  if ($[6] !== osName || $[7] !== type) {
    t4 = isMobileKind(type) && isIOS(osName);
    $[6] = osName;
    $[7] = type;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isMobileOrTabletIOS = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <style>{"\n          @media (max-width: 899px) {\n            #footprint-footer { display: none; }\n            #idv-body-content-container > div { padding-bottom: 0; }\n          }\n        "}</style>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClose || $[13] !== t6) {
    t7 = <IconButton className={TOUCH_TARGET_CLASS} aria-label={t6} onClick={onClose} icon={IcoClose24} color="primary" />;
    $[12] = onClose;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== browser || $[16] !== isMobileOrTabletAndroid || $[17] !== isMobileOrTabletIOS || $[18] !== t) {
    t8 = isMobileOrTabletIOS && isSafari(browser) ? <div className="flex justify-center mb-10"><img src={`${gifBaseUrl}/settings-cam-ios-safari.gif`} alt={t(_temp2)} width="210" height="269" className="rounded-lg" /></div> : isMobileOrTabletIOS && isChrome(browser) ? <div className="flex justify-center mb-10"><img src={`${gifBaseUrl}/settings-cam-ios-chrome.gif`} alt={t(_temp3)} width="210" height="269" className="rounded-lg" /></div> : isMobileOrTabletAndroid && isChrome(browser) ? <div className="flex justify-center mb-10"><img src={`${gifBaseUrl}/settings-cam-android-chrome.gif`} alt={t(_temp4)} width="210" height="233" className="rounded-lg" /></div> : <div className="flex justify-center mb-6"><IcoCamera40 color="primary" /></div>;
    $[15] = browser;
    $[16] = isMobileOrTabletAndroid;
    $[17] = isMobileOrTabletIOS;
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t(_temp5);
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <div className="text-heading-3 text-center mb-3 text-primary">{t9}</div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== browser || $[25] !== isMobileOrTabletAndroid || $[26] !== isMobileOrTabletIOS || $[27] !== t) {
    t11 = isMobileOrTabletIOS && isSafari(browser) ? <><span className="text-body-1 text-center text-primary">{t(_temp6)}</span><span className="text-label-1 text-center text-primary">{t(_temp7)}</span></> : isMobileOrTabletIOS && isChrome(browser) ? <span className="text-body-1 text-center text-primary">{t(_temp8)}</span> : isMobileOrTabletAndroid && isChrome(browser) ? <span className="text-body-1 text-center text-primary"><Trans ns="idv2" i18nKey={_temp9} components={{
        bold: <strong />
      }} /></span> : <span className="text-body-1 text-center text-primary">{t(_temp10)}</span>;
    $[24] = browser;
    $[25] = isMobileOrTabletAndroid;
    $[26] = isMobileOrTabletIOS;
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t8) {
    t12 = <div className="flex flex-col justify-center h-full">{t8}{t10}{t11}</div>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t8;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== browser || $[34] !== isMobileOrTabletIOS) {
    t13 = isMobileOrTabletIOS && isSafari(browser) ? <div className="ml-6"><IcoArrowCustom /></div> : null;
    $[33] = browser;
    $[34] = isMobileOrTabletIOS;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t12 || $[37] !== t13 || $[38] !== t7) {
    t14 = <>{t5}{t7}{t12}{t13}</>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t7;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};
export default CameraAccessDenied;
function _temp($) {
  return $.components["missing-permissions"]["close-aria-label"];
}
function _temp2($_0) {
  return $_0.components["missing-permissions"]["settings-image-alt"]["safari-ios"];
}
function _temp3($_1) {
  return $_1.components["missing-permissions"]["settings-image-alt"]["chrome-ios"];
}
function _temp4($_2) {
  return $_2.components["missing-permissions"]["settings-image-alt"]["chrome-android"];
}
function _temp5($_3) {
  return $_3["access-camera"];
}
function _temp6($_4) {
  return $_4["go-to-camera-settings"];
}
function _temp7($_5) {
  return $_5["then-refresh-page"];
}
function _temp8($_6) {
  return $_6["go-to-chrome-settings"];
}
function _temp9($_7) {
  return $_7["document-flow"]["go-to-chrome-url"];
}
function _temp10($_8) {
  return $_8["go-to-device-settings"];
}